module.exports = __webpack_public_path__ + "static/media/bosnia-and-herzegovina.0fb9c0c6.svg";